import { apiRequest } from '../config/api';

export interface AssistantArtifact {
  id: string;
  type: 'diagram' | 'registry_entry' | string;
  title: string;
  subtitle?: string;
  app_path: string;
  project_id: string;
  metadata?: Record<string, string>;
}

export interface AssistantSearchResult {
  artifact: AssistantArtifact;
  score: number;
  matches: string[];
}

export interface AssistantSearchResponse {
  results: AssistantSearchResult[];
}

export interface AssistantChatResponse extends AssistantSearchResponse {
  answer_text?: string;
  used_llm: boolean;
  provider_id?: string;
  fallback_reason?: string;
  token_usage?: number;
  chat_id?: string;
}

export interface AssistantProvider {
  id: string;
  label: string;
  model: string;
  configured: boolean;
  custom: boolean;
  has_api_key: boolean;
  timeout_seconds?: number;
}

export interface AssistantProvidersResponse {
  providers: AssistantProvider[];
}

export interface AssistantChatHistoryItem {
  id: string;
  query: string;
  answer_text?: string;
  project_ids: string[];
  results: AssistantSearchResult[];
  used_llm: boolean;
  provider_id?: string;
  provider_model?: string;
  fallback_reason?: string;
  token_usage?: number;
  created_at: string;
}

export interface AssistantChatHistoryResponse {
  chats: AssistantChatHistoryItem[];
}

export async function searchAssistant(projectId: string, query: string, limit = 12): Promise<AssistantSearchResponse> {
  return apiRequest(`/projects/${encodeURIComponent(projectId)}/assistant/search`, {
    method: 'POST',
    body: JSON.stringify({ query, limit }),
  });
}

export async function askAssistant(projectIds: string[], query: string, limit = 12, providerId?: string): Promise<AssistantChatResponse> {
  const body: { query: string; limit: number; project_ids: string[]; provider_id?: string } = {
    query,
    limit,
    project_ids: projectIds,
  };
  if (providerId) body.provider_id = providerId;
  return apiRequest('/assistant/chat', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function listAssistantProviders(): Promise<AssistantProvidersResponse> {
  return apiRequest('/assistant/providers', { method: 'GET' });
}

export async function listAssistantChats(): Promise<AssistantChatHistoryResponse> {
  return apiRequest('/assistant/chats', { method: 'GET' });
}
